import React from "react";

function About() {
  return (
    <div>
        <h1>About as</h1>
      <p>
       
        Fly ash brick machines are machines that are used to produce bricks made
        from fly ash, a byproduct of coal combustion. These bricks are a
        sustainable and eco-friendly alternative to traditional clay bricks, as
        they use less energy to produce and can help to reduce the amount of fly
        ash waste in the environment. The machines typically consist of a mixing
        unit, a molding unit, and a curing unit. They can be operated manually
        or automatically, and can produce a variety of different types and sizes
        of bricks.
      </p>

      <p>
        A fully automatic fly ash brick making machine is a machine that can
        produce bricks made of fly ash without the need for manual labor. These
        machines typically use fly ash, cement, and other materials to produce
        bricks that are strong and durable. They can be used to produce bricks
        for a wide range of construction projects, including houses, buildings,
        and infrastructure projects. The machines typically consist of several
        components, including a mixer, a molding machine, and a curing chamber.
        The mixer is used to mix the fly ash, cement, and other materials
        together. The molding machine is used to shape the mixture into bricks.
        The curing chamber is used to cure the bricks, ensuring that they are
        strong and durable. Fully automatic fly ash brick making machines are
        widely used in construction sites, brick making factories and other
        places where large numbers of bricks are required. They are efficient
        and can produce high-quality bricks in large quantities. They also have
        the advantage of being easy to operate and maintain. You can find many
        suppliers of fully automatic fly ash brick making machines online, and
        can compare the prices, features and the quality of the machine.
      </p>

      <div>
        <h1 className="Contactas ">Contact as </h1>
        <iframe
          title="This is a unique title"
          src="https://docs.google.com/forms/d/e/1FAIpQLSeEkIWyed5RedYU6NcKMlrDAOcE6Qe7PG8O_aDBDArlUCDCLA/viewform?embedded=true"
          width="640"
          height="812"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
}

export default About;
